import _ from "../../utils/underscore";
import Store from "../../utils/store";
import ServiceFactory from "../service_factory";
import {SYSTEM_EVENTS} from "../../events/events";
import Event from "../../utils/event";
import {IObservableSubscription} from "../../utils/observable";
import BaseObject from "../../base/base_object";
import {Check} from "@sparkware/app-utils";

const CLIENT_IPs_STORAGE_KEY: string = "ClientIPs";
const SHOULD_SEND_IPs_STORAGE_KEY: string = "shouldSendIPs";

export class ClientIpsHandler extends BaseObject {
    constructor(private readonly serviceFactory: ServiceFactory) {
        super();
        Event.on(SYSTEM_EVENTS.GEO_LOCATION_FAILED, this._resetIPsList);
        this._setShouldSendIPs(true, true);
        this._clearIPsFromLocalStorage();
    }

    private _ipResponseTimeout:IObservableSubscription;

    extractClientIpFromResponseHeaders(headers: Headers): void {

        try {
            if (headers && (this._shouldSendIPs === false)) {
                let currentClientIP: string = headers.get("current-client-request-ip");
                if (currentClientIP) {
                    if(this._getClientIPs().indexOf(currentClientIP) === -1) {
                        this._addClientIP(currentClientIP);
                    }
                    this._setShouldSendIPs(true);
                    this._disposeIPRequestTimer();
                }
            }
        }
        catch (err){
            this.logger.error("Exception when trying to get current-client-request-ip from response headers", err);
        }
    }

    private _setShouldSendIPs(value:boolean, setOnlyIfExpired:boolean = false){
        if(setOnlyIfExpired === true){
            const { timestamp } = _.safeJSON(Store.get(SHOULD_SEND_IPs_STORAGE_KEY), {}) || {};
            if (!Check.isNullOrUndefined(timestamp)){
                if(Date.now()-timestamp<30000)//"not older than 30 s"
                {
                    return;
                }
            }
        }
        Store.set(SHOULD_SEND_IPs_STORAGE_KEY, JSON.stringify({value:value,timestamp:Date.now()}));
    }

    private get _shouldSendIPs():boolean{
        const { value, timestamp } = _.safeJSON(Store.get(SHOULD_SEND_IPs_STORAGE_KEY), {}) || {};
        if (!Check.isNullOrUndefined(value)){
            if(Date.now()-timestamp<30000)//not older than 30 sec
            {
                return value;
            }
            else
            {
                return true;
            }
        }
        return true;
    }


    private  _getClientIPs():Array<string>{
        let clientIPs:Array<string>;
        try {
            clientIPs = _.safeJSON(Store.get(CLIENT_IPs_STORAGE_KEY), null);
        }
        catch (err){
            console.log("Couldn't get IPs list from local storage.")
        }

        if(Check.isArray(clientIPs)){
            return clientIPs;
        }
        else{
            return [];
        }
    }

    private _addClientIP(clientIP:string){
        const clientIPs = this._getClientIPs();
        clientIPs.push(clientIP);
        Store.set(CLIENT_IPs_STORAGE_KEY, JSON.stringify(clientIPs));
    }


    private _disposeIPRequestTimer():void {
        this._ipResponseTimeout?.dispose();
        this._ipResponseTimeout = null;
    }

    private _resetIPsList = () => {
        this._clearIPsFromLocalStorage();
        this._setShouldSendIPs(true);
    }

    private _clearIPsFromLocalStorage(){
        Store.del(CLIENT_IPs_STORAGE_KEY);
    }

    beginNewRequest(): string | null {
        try {
            if(this._shouldSendIPs) {

                this._setShouldSendIPs(false);
                this._ipResponseTimeout = this.serviceFactory.observableFactoryService().fromTimeout(20000)
                    .forEach(() => {
                        this._setShouldSendIPs(true);
                        this._disposeIPRequestTimer();
                    })

                return this._getClientIPs().toString();
            }
        }
        catch (err){
            this.logger.error("Exception when trying to add IP parameter to request", err);
        }

        return null;
    }
}